var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 3.75C7.94022 3.75 7.46331 3.94754 7.11168 4.29918C6.76004 4.65081 6.5625 5.12772 6.5625 5.625V24.375C6.5625 24.8723 6.76004 25.3492 7.11168 25.7008C7.46331 26.0525 7.94022 26.25 8.4375 26.25H21.5625C22.0598 26.25 22.5367 26.0525 22.8883 25.7008C23.24 25.3492 23.4375 24.8723 23.4375 24.375V12.964C23.4375 12.964 23.4375 12.9639 23.4375 12.9639C23.4374 12.7154 23.3387 12.4771 23.1631 12.3014C23.163 12.3014 23.163 12.3013 23.163 12.3013L14.8862 4.02451C14.7104 3.84881 14.4721 3.75007 14.2236 3.75C14.2236 3.75 14.2235 3.75 14.2235 3.75H8.4375ZM5.78585 2.97335C6.48911 2.27009 7.44294 1.875 8.4375 1.875H14.2238C14.9694 1.87511 15.6845 2.17133 16.2119 2.69854L16.2119 2.69861L24.489 10.9756C25.0162 11.503 25.3124 12.2181 25.3125 12.9637V24.375C25.3125 25.3696 24.9174 26.3234 24.2142 27.0267C23.5109 27.7299 22.5571 28.125 21.5625 28.125H8.4375C7.44294 28.125 6.48911 27.7299 5.78585 27.0267C5.08259 26.3234 4.6875 25.3696 4.6875 24.375V5.625C4.6875 4.63044 5.08259 3.67661 5.78585 2.97335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.34375C15.5178 2.34375 15.9375 2.76348 15.9375 3.28125V10.3125C15.9375 10.5611 16.0363 10.7996 16.2121 10.9754C16.3879 11.1512 16.6264 11.25 16.875 11.25H23.9062C24.424 11.25 24.8438 11.6697 24.8438 12.1875C24.8438 12.7053 24.424 13.125 23.9062 13.125H16.875C16.1291 13.125 15.4137 12.8287 14.8863 12.3012C14.3588 11.7738 14.0625 11.0584 14.0625 10.3125V3.28125C14.0625 2.76348 14.4822 2.34375 15 2.34375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 16.875C9.375 16.3572 9.79473 15.9375 10.3125 15.9375H19.6875C20.2053 15.9375 20.625 16.3572 20.625 16.875C20.625 17.3928 20.2053 17.8125 19.6875 17.8125H10.3125C9.79473 17.8125 9.375 17.3928 9.375 16.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 21.5625C9.375 21.0447 9.79473 20.625 10.3125 20.625H19.6875C20.2053 20.625 20.625 21.0447 20.625 21.5625C20.625 22.0803 20.2053 22.5 19.6875 22.5H10.3125C9.79473 22.5 9.375 22.0803 9.375 21.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.6871f40abe05f921b87aa853b5e4a8b8.svg";
export { ForwardRef as ReactComponent };